export function areObjectsShallowEqual<T extends object>(a: T, b: T): boolean {
  if (a === b) return true;

  const keysA = (Object.keys(a) as unknown) as ReadonlyArray<keyof T>;
  const keysB = (Object.keys(b) as unknown) as ReadonlyArray<keyof T>;

  if (keysA.length !== keysB.length) return false;

  return keysA.every(key => a[key] === b[key]);
}
